import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/groupBusiness",
    name: "GroupBusiness",
    component: () => import("@/views/GroupBusiness.vue"),
  },
  {
    path: "/groupNews",
    name: "GroupNews",
    component: () => import("@/views/GroupNews.vue"),
  },
  {
    path: "/groupDetail",
    name: "GroupDetail",
    component: () => import("@/views/GroupDetail.vue"),
  },
  {
    path: "/newsDetail",
    name: "NewsDetail",
    component: () => import("@/views/NewsDetail.vue"),
  },
  {
    path: "/expertTeam",
    name: "ExpertTeam",
    component: () => import("@/views/ExpertTeam.vue"),
  },
  {
    path: "/aboutUs",
    name: "AboutUs",
    component: () => import("@/views/AboutUs.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
